import { Component, OnInit, OnChanges } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ReportService } from '../services/report.service';
import { tap } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';

import { Base64Images } from '../model/base64-images';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tcc-reports',
  templateUrl: './tcc-reports.component.html',
  styleUrls: ['./tcc-reports.component.scss']
})
export class TccReportsComponent implements OnInit {

  public reportData : Array<any>;
  public filterData: Array<any>;
  public width = 10;
  public height= 30;
  public head = ['TAXPAYER NAME','REQUEST DATE', 'REQUEST STATUS', 'DIVISION NO']
  // public tccRep$: Observable<boolean>;  
  repForm : FormGroup;  
  public images : Base64Images;
  private _tableIsVisible: boolean = true;
  
  constructor(private fb: FormBuilder, private reportService: ReportService,private router:Router) {}

  ngOnInit() {
    this.reportService.getReportData1().subscribe(data=>{
      this.reportData=data;
      console.log(this.reportData);
    })
    this.createAddCommentForm();
    this.tableIsVisible = false;
    //this.filterData=[];
  }
  public get tableIsVisible(): boolean {
    return this._tableIsVisible;
  }
  public set tableIsVisible(value: boolean) {
    this._tableIsVisible = value;
  }

  private createAddCommentForm(){
    this.repForm = this.fb.group({
     division: [''],
     status: [''],
     from_date: [''],
     to_date: ['']
    })
  }

  downloadReport(){
    let doc = new jsPDF();
    this.images = new Base64Images();
      doc.addImage(this.images.sealImg,10,10,20,20)
      doc.setFontSize(25);
      doc.setTextColor(237,28,36)
      doc.text("TAX CLEARANCE REPORT",38, 20);
      doc.addImage(this.images.lraImgData,180,10,20,15);
      doc.setFontSize(18);
      doc.setTextColor(0,0,128);
      doc.text(this.repForm.controls.division.value,68, 30);
      doc.setFontSize(14);
      doc.setTextColor(0,0,0)
      doc.setFontSize(14);
      doc.setTextColor(237,28,36);
      (doc as any).autoTable({html: '#tcc_rep_table'})
      
    this.reportData.filter(res=>{return res.TAX_DIVISION_NO==this.repForm.controls.division.value})
                    .filter(res=>{return res.REQUEST_STATUS.indexOf(this.repForm.controls.status.value)>-1})
                    .map(data=>{
                      this.filterData= data;   
                     // console.log(this.filterData);
                    });
                    // .forEach(res=>{
                    //   this.height+=10;
                    //   doc.text(res.TAXPAYER_NAME,this.width, this.height);
                    //   doc.text(res.REQUEST_STATUS,this.width+100, this.height);
                      
                    // })
                   // this.tableIsVisible=true;
                   //.forEach(res=>{console.log(res.TAXPAYER_NAME+" "+res.REQUEST_STATUS+" "+res.TAX_DIVISION)});
        // Open PDF document in new tab
        (doc as any).autoTable({
          head:this.head,
          body: this.filterData,
          startY: 15,
       /* apply styling to table body */
      bodyStyles: {
        valign: 'top'
      },
        /* apply global styling */
        styles: {
          cellWidth: 'wrap',
          rowPageBreak: 'auto',
          halign: 'justify'
        },
        /* apply styling specific to table columns */
        columnStyles: {
            text: {
               cellWidth: 'auto'
           }
        }
          
        });
        doc.output('dataurlnewwindow')
        doc.save("report"+".pdf");

      
      
}

  


 
 

}

